import React from "react";
import LodgeLayout from "../components/lodge-components/lodgeLayout"; // Relative path to lodgeLayout

const Lodge: React.FC = () => {
  return <LodgeLayout />;
};

export default Lodge;
